import { render } from "./HousingRegister.vue?vue&type=template&id=296224ca&scoped=true"
import script from "./HousingRegister.vue?vue&type=script&lang=js"
export * from "./HousingRegister.vue?vue&type=script&lang=js"

import "./HousingRegister.vue?vue&type=style&index=0&id=296224ca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-296224ca"]])

export default __exports__